export default "__VITE_ASSET__BYyzb$yj__"